import { flow, map, filter, sum, get, getOr, find } from 'lodash/fp';
import { includedIn } from '@gcc/nodash';

const includedPurchaseOptions = ['product-and-install', 'product-only'];

export default (allItems, prop, container) => flow(
  map(id => get(id)(allItems)),
  filter(flow(
    get('attributes'),
    find({ name: 'purchaseOption' }),
    get('value'),
    includedIn(includedPurchaseOptions),
  )),
  map(getOr(0, prop)),
  sum,
)(container.items);
